<template>
  <div class="page-box">
    <div class="state-ul">
      <div class="state-li" v-for="(item, index) in List" :key="index" :class="{ active: active === item.value }" @click="setActive(item.value)">{{ item.name }}</div>
    </div>
    <div class="study-box">
      <CommentList :list2="showList" :page="page" @sizeChange="sizeChange" @currentChange="currentChange" />
    </div>
  </div>
</template>

<script>
import CommentList from "@/views/PersonalCenter/components/CommentList.vue";
import { getUserComment } from '@/api/user'
export default {
  name: "LearningProgress",
  components: {
    CommentList
  },
  data() {
    return {
      active: 'SUCCESS',
      List: [
        {
          name: '已审核',
          value: 'SUCCESS',
        },
        {
          name: '审核中',
          value: 'ING',
        },
        {
          name: '未通过',
          value: 'FAILED',
        }
      ],
      showList: [],
      page: {
        number: 1,
        limit: 10,
        total: 0,
      }
    }
  },
  methods: {
    setActive(index) {
      this.active = index;
      this.page.number = 1
      this.getUserComment()
    },
    // 分页查询我的评论
    getUserComment() {
      getUserComment({
        number: this.page.number,
        limit: this.page.limit,
        checkStatus: this.active,
      }).then(res => {
        this.showList = res.data
        this.page.total = res.totalCount
      })
    },
    sizeChange(value) {
      this.page.number = 1
      this.page.limit = value
      this.getUserComment()
    },
    currentChange(value) {
      this.page.number = value
      this.getUserComment()
    },
  },
  mounted() {
    this.getUserComment()
  },
}
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/views/PersonalCenter/components/MyComment.vue